import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Router } from '@angular/router';
import { UserSettingsService } from '../../../settings/service/user-settings.service';

@Injectable()
export class InitErrorGuard implements CanActivate {

  constructor(private userSettings: UserSettingsService, private router: Router) { }

  canActivate(): boolean {
    if (this.userSettings.isSettingsLoaded()) {
      void this.router.navigate(['/home']);
      return false;
    }
    return true;
  }
}
